import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { HeaderCell } from '.';

const TableHeaderRow = memo(({ config, handleSort, theme }) => (
  <tr className={`${theme === 'light' ? '' : 'thead-dark'}`}>
    {config.map((conf) => (
      <HeaderCell
        key={conf.dataField}
        handleSort={handleSort}
        sort={conf.sort}
        align={conf.align}
        sortingId={conf.dataField}
        padding={conf.padding}
      >
        {conf.caption}
      </HeaderCell>
    ))}
  </tr>
));

TableHeaderRow.propTypes = {
  config: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSort: PropTypes.func,
  padding: PropTypes.string,
  theme: PropTypes.string.isRequired,
};

TableHeaderRow.defaultProps = {
  handleSort: () => { },
  padding: 'default',
};

export default TableHeaderRow;
